/**
 * Brand-aware categorical chart palette.
 *
 * Lickly gets an on-brand DS palette (pink / teal / champagne / leather-grey + tints); every other
 * brand receives the `fallbackColors` passed in (that chart's existing palette), so nothing
 * changes off-Lickly. Highcharts uses the SVG renderer and the legend swatches are inline
 * styles, so the `var()` tokens resolve in both the series fills and the swatch backgrounds.
 *
 * Centralises the brand gate that was being duplicated per chart (AAPU-6711).
 *
 * @type {string[]}
 */
export const LICKLY_CATEGORICAL_CHART_COLORS = [
  'var(--ds-pink-500)',
  'var(--ds-blue-500)',
  'var(--ds-champagne-500)',
  'var(--ds-neutral-600)', // leather-grey — Nita: DS green clashed with the palette
  'var(--ds-info-500)',
  'var(--ds-pink-300)',
  'var(--ds-blue-300)',
  'var(--ds-champagne-300)',
];

/**
 * @param {string[]} [fallbackColors] - palette used for non-Lickly tenants (the chart's own).
 * @returns {string[]} the palette to feed a chart's `colorArray` / `colorByPoint` series.
 */
const getCategoricalChartColors = (fallbackColors = []) => {
  const isLickly =
    typeof document !== 'undefined' &&
    document.documentElement.getAttribute('data-tenant') === 'lickly';
  return isLickly ? LICKLY_CATEGORICAL_CHART_COLORS : fallbackColors;
};

export default getCategoricalChartColors;
